import HorizontalThermometer from './HorizontalThermometer';

export default HorizontalThermometer;
